module.exports = new __parcel__URL__("snare_9.3d8c9482.mp3").toString();